<template>

  <div>
   

      <select v-if="estaVacio" v-model="idDelModelo" @focus="eventoActual()" @change="cambiarDatosSubmenu($event)" id="sel" class="form-control"   style="border-top-width: 0px;margin-top: 7px;margin-bottom: 16px;padding-left: 0px;">
         <option :value="-1" :key="-1">Seleccione opción</option>     
        <option v-for="(submenu,index) in obtenerSubmenus" :value="submenu.SubmenuId" :key="index">{{submenu.Titulo}}</option>        
      </select>      

  <div style="margin-top:2em">

   <!-- <div v-if="tieneMasSubmenus" v-for="(subMic,index) in this.Submenus" :key="index" style="margin-top:2em"> -->
 <Select v-if="obtenerSubmenus.length >=1"  
   :Submenus="submenusRecursivos" 
   :EsEdicion="editandoSubMenu" 
   :Parametros="parametrosHijo"
   :SubMenuAnterior="menuAnterior" 
   :valorDefinido="valorDefinidoHijo"  
    v-on:valorParaElPadre="cambioSubmenuHijo" 
    :key="recursiveKey"></Select> 



</div> 





    
  </div>
</template>
<script>
 import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import axios from 'axios'

export default {
  name:"Select",
  data() {
    return {
      valorDefinidoHijo:null,
      parametrosHijo:{},
      idDelModelo:0,
      submenusMicrositio:[],
      keySubmenu:-1,
      tieneMasSubmenus:false,
      subMic:[],
      objetoSeleccionado:{},
      grupoDeSubmenus:[],
      submenusRecursivos:[],
      recursiveKey:null,
      estaVacio:true,
      editandoSubMenu:false,
      menuAnterior:0
    }
  },
  props:{
    Submenus:Array,
    valorDefinido:Number,
    EsEdicion:Boolean,
    Parametros:Object,
    SubMenuAnterior:Number

  },
  computed:{
    obtenerSubmenus(){
      return this.grupoDeSubmenus;
    },
    obtenerSubmenusRecursivos(){
      return submenusRecursivos;
    }

  },
  methods: {

    eventoActual:function(){
this.menuAnterior =parseInt(this.idDelModelo);
this.$store.dispatch("A_SICPO_Catalogos_SubMenuAnterior",parseInt(this.idDelModelo));
//console.log("this.idDelModelothis.idDelModelothis.idDelModelo;;",this.idDelModelo)
    },
      cambioSubmenuHijo(event,objetoSelec) {

       this.$emit('valorParaElPadre',event,objetoSelec,this.$store.getters.Get_SICPO_Catalogos_SubMenuAnterior);
      //  this.$emit("valorParaElPadre", evento,menuObjSeleccionado);
        },  

       cambiarDatosSubmenu(evento,objetoSelec){
    //    console.log("ultimo DATO:::"+valorAnterior.data("prev"))
        this.idDelModelo = evento.target.value;
        const valoresDelCatalogo =
        {
          llave: this.idDelInput,
          valor: evento.target.value 
        }

        let menuObjSeleccionado = this.Submenus.find(m => m.SubmenuId == evento.target.value);
        this.objetoSeleccionado = menuObjSeleccionado;
        if(menuObjSeleccionado!=undefined)this.agregarSubmenusRecursivos(menuObjSeleccionado.SubmenusQueMePertenecen,evento.target.value)
        else this.agregarSubmenusRecursivos([],evento.target.value)
        this.$emit("valorParaElPadre", evento,menuObjSeleccionado,this.$store.getters.Get_SICPO_Catalogos_SubMenuAnterior);
        // para obtener label del select => let labelTipoPagina = evento.target.options[evento.target.selectedIndex].text;
      },
      agregarSubmenusRecursivos(arregloSubmenus,key){
        this.submenusRecursivos =  arregloSubmenus
        this.recursiveKey =arregloSubmenus.length+key;
      },

       cargarSubMenus: function(llave) {
        // definimos metodo de API
        const SERVIDOR = api.conexion;
        const METODO_API_OBTENER = api.SICPO.catalogos.C004Menus;
        let urlApi = SERVIDOR + api.SICPO.sistema.paginaweb.administracionDeSubmenus.ObtenerSubmenusPW  ;  //"SICPO/AdministracionDeSubmenusPW/ObtenerSubmenusPaginaWeb";
        // creamos la peticion con el formulario
        var parametros = {}
        if(parametros == null || parametros == undefined)
          
        
        parametros.EsPrueba = this.enumeraciones.EsPrueba;
         parametros.MenuId = llave;
        // contruir header de la peticion
        let peticionArchivos = false;
        let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos);

        axios.post(urlApi,parametros, headerPeticion)
                .then(respuesta => {            
                    if (respuesta.data.SiHayError) {
                        console.log(respuesta); 
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    } else {
                      console.log("RESPUESTA CORRECTA")
                      console.log(respuesta.data);
                    //   this.submenusRecursivos = respuesta.data.Submenus;
                    //   this.grupoDeSubmenus = respuesta.data.Submenus;
                    //   this.idDelModelo = this.valorDefinido;
                    //   this.editandoSubMenu =false;
                    //  this.keySubmenu = this.keySubmenu+ 1;
                      /* utilizar solo en etapa de desarrollo 
               console.log("Console1")       
                        console.log("ejecuto bien paginas controller:: ",respuesta.data); */
                       // this.menus = respuesta.data.Menus;
                    }
                })
                .catch(excepcion => {
                    console.log(excepcion);
                    comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
                }
        ) // axios.post
      },

        regresaMenus:function(subMenus){  
          //console.log("RegresaSubmenus")
          this.estaVacio = (subMenus.length==0)?false:true;
          subMenus= subMenus;
          this.grupoDeSubmenus=subMenus
          if(subMenus != undefined && subMenus!=null && this.EsEdicion && this.Parametros.MenuId != undefined )this.cargarSubMenus()
return subMenus

        },
    
  },


mounted() {
  this.regresaMenus( this.Submenus);
 this.grupoDeSubmenus=this.Submenus;
},


}
</script>


// WEBPACK FOOTER //
// src/components/SICPO/Micrositios/Menu/SelectRecursivoMicrositio.vue